export default __webpack_public_path__ + "static/media/tree_1_unlocked.06a94a2f.png";